<template>
  <div>
    <h1 class="title is-h1">Reset Password</h1>
    <p>Your password has been reset by an administrator, so you now must choose a new password.</p>

    <div class="notification is-danger" v-if="errorMessage">
      {{ errorMessage }}
    </div>

    <form @submit.prevent="handleSubmit">
      <b-field label="New Password">
        <b-input type="password" :required="true" v-model.trim="password"></b-input>
      </b-field>
      <button type="submit" class="button is-primary">Set Password</button>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    submit: Function
  },
  data () {
    return {
      password: null,
      loading: false,
      errorMessage: null
    }
  },
  methods: {
    handleSubmit () {
      this.loading = true

      // try to submit the new password to the provided callback function
      this.submit(this.password, null)
        .then(() => {
          // success - emit the password
          this.$emit('password', this.password)
        })
        .catch((e) => {
          this.errorMessage = e.message
        })
        .then(() => {
          this.loading = false
        })
    }
  }
}
</script>
